'use strict';

var get = require('lodash/get');

var ClientFactory = require('./client');
var keyParser = require('../utils/key/parser');

var _require = require('../utils/constants'),
    LOCALHOST_MODE = _require.LOCALHOST_MODE;

function FixKey(context) {
  var _client$track;

  var settings = context.get(context.constants.SETTINGS);
  var key = get(settings, 'core.key', undefined);
  var tt = get(settings, 'core.trafficType', undefined);

  if (settings.mode === LOCALHOST_MODE && key === undefined) {
    settings.core.key = 'localhost_key';
  } else {
    keyParser(key);
  }

  var client = ClientFactory(context);
  client.isBrowserClient = true;

  // In the browser land, the key is required on the settings, so we can bind it to getTretment/s
  client.getTreatment = client.getTreatment.bind(client, settings.core.key);
  client.getTreatments = client.getTreatments.bind(client, settings.core.key);

  // Key is also binded to the .track method. Same thing happens with trafficType but only if present on configs. (not required)
  var trackBindings = [settings.core.key];
  if (tt) {
    trackBindings.push(tt);
  }
  client.track = (_client$track = client.track).bind.apply(_client$track, [client].concat(trackBindings));

  return client;
}

module.exports = FixKey;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/client/browser.js
// module id = 654
// module chunks = 10